export const CUSTOMER_ANNUAL_REVENUE_ANALYSIS_COLUMNS = (years, isExport) => {
  const yearColumns = years.sort().reduce(
    (acc, year) => [
      ...acc,
      {
        Header: `${year} Actual`,
        accessor: `yearGroups.${year}.actualHours`,
        id: "actualHours",
        Cell: isExport
          ? ({ value }) => (value && value.toFixed(1)) || "--"
          : (row) =>
              row.original?.yearGroups[year] &&
              row.original.yearGroups[year].actualHours
                ? row.original.yearGroups[year].actualHours.toFixed(1)
                : "--",
        minWidth: 120
      },
      {
        Header: `${year} Billable`,
        accessor: `yearGroups.${year}.billableHours`,
        id: "billableHours",
        Cell: isExport
          ? ({ value }) => (value && value.toFixed(1)) || "--"
          : (row) =>
              row.original?.yearGroups[year] &&
              row.original.yearGroups[year].billableHours
                ? row.original.yearGroups[year].billableHours.toFixed(1)
                : "--",
        minWidth: 100
      }
    ],
    []
  );

  return [
    {
      Header: "Customer",
      accessor: "customerName",
      id: "customerName",
      minWidth: 200
    },
    {
      Header: "Contract",
      id: "contractName",
      accessor: "contractName",
      minWidth: 200
    },
    {
      Header: "Call Type",
      accessor: "callTypeName",
      id: "callTypeName",
      minWidth: 100
    },
    ...yearColumns,
    {
      Header: "Total Actual",
      accessor: "totalActualHours",
      id: "totalActualHours",
      Cell: ({ value }) => (value && value.toFixed(1)) || "--",
      minWidth: 100
    },
    {
      Header: "Total Billable",
      accessor: "totalBillableHours",
      id: "totalBillableHours",
      Cell: ({ value }) => (value && value.toFixed(1)) || "--",
      minWidth: 100
    }
  ];
};
